import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import GameService from "service/GameService";
import { GameCard } from "components/games/GameCard";
import { API_URL } from "helper/Constants";
import { useTranslation } from "react-i18next";

const GamesByCategory = ({ data, title, limit = null }) => {
  const { t } = useTranslation();
  const gameService = new GameService(API_URL);
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [offset, setOffset] = useState(0);
  const [totalGames, setTotalGames] = useState(0);

  useEffect(() => {
    const loadGames = async (append = false) => {
      setLoading(true);
      const filters = {
        ...(data?.type ? { type: data.type } : {}),
        ...(data?.category ? { category: data.category } : {}),
      };
      try {
        const response = await gameService.fetchGames(offset, limit || append ? 16 : 32, filters);
        setGames((prevGames) => (append ? [...prevGames, ...response.data] : response.data)); // Append only when `append` is true
        setTotalGames(response.pagination?.total);
      } catch (error) {
        console.error("Failed to load games:", error);
      } finally {
        setLoading(false);
      }
    };

    if (offset === 0) {
      loadGames(); // Load initially
    } else {
      loadGames(true); // Append for load more
    }
  }, []);

  const displayedGames = limit ? games.slice(0, limit) : games;

  if (loading && offset === 0) {
    return (
      <div className="px-2">
        <div className="flex items-center justify-center h-[calc(100vh-400px)] bg-[rgb(25,38,59)] ">
          <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="px-2">
        <div className="flex items-center justify-center h-[calc(100vh-400px)] bg-[rgb(25,38,59)] text-red-500">
          {error.includes("Failed to fetch games") ? "Unable to load games. Please try again later." : error}
        </div>
      </div>
    );
  }

  return (
    <div key={data.length++} className="p-2">
      <div className="flex justify-between">
        <h4 className="text-white uppercase text-lg font-semibold">{title}</h4>
        <Link to={data.path} className="text-gray capitalize">
          {t("more")} <i className="bc-i-small-arrow-right text-[10px]"></i>
        </Link>
      </div>
      {games && games.length ? (
        <div
          className={
            "grid md:grid-cols-5 grid-rows-1 auto-cols-[150px] lg:gap-3 gap-2 overflow-x-auto overflow-y-hidden hide-scrollbar scroll-smooth"
          }
          style={{
            display: "grid",
            gridAutoFlow: "column",
            WebkitOverflowScrolling: "touch", // For smooth iOS scrolling
          }}
        >
          {displayedGames.map((game, index) => (
            <GameCard key={index || game.id} data={game} />
          ))}
        </div>
      ) : (
        <div className="flex items-center justify-center h-[calc(100vh-600px)] bg-[rgb(25,38,59)] text-white mb-4">
          {t("No games available at the moment")}...
        </div>
      )}
    </div>
  );
};

export default GamesByCategory;
